(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

/************************/
/* Global Configuration */
/************************/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GlobalConfig = {
		root: null,
		modalSelector: '',
		triggerSelectors: [],
		dismissSelectors: [],
		rootActiveClass: '',
		modalActiveClass: 'is-visible',
		dismissOnFocusLost: true
};

/********************/
/* Global Constants */
/********************/
var ID_POOL_PREFIX = 'modal-';
var DATA_PREFIX = 'data-modal-';

/*********************/
/* Private Variables */
/*********************/
// jQuery formatted selector to search for focusable items
var _focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
// store the item that has focus before opening the modal window
var _focusedElementBeforeModal;

var _modals = {};

// var _eventNamespace = 'm-';
var _idPool = 0;

/*************/
/* Polyfills */
/*************/
if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (obj, fromIndex) {
				if (fromIndex == null) {
						fromIndex = 0;
				} else if (fromIndex < 0) {
						fromIndex = Math.max(0, this.length + fromIndex);
				}
				for (var i = fromIndex, j = this.length; i < j; i++) {
						if (this[i] === obj) return i;
				}
				return -1;
		};
}

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {

		Array.prototype.map = function (callback, thisArg) {

				var T, A, k;

				if (this == null) {
						throw new TypeError(' this is null or not defined');
				}

				var O = Object(this);
				var len = O.length >>> 0;

				if (typeof callback !== 'function') {
						throw new TypeError(callback + ' is not a function');
				}

				if (arguments.length > 1) {
						T = thisArg;
				}

				A = new Array(len);

				k = 0;

				while (k < len) {

						var kValue, mappedValue;

						if (k in O) {
								kValue = O[k];
								mappedValue = callback.call(T, kValue, k, O);

								A[k] = mappedValue;
						}

						k++;
				}

				return A;
		};
}

/*********************/
/* Private Functions */
/*********************/
function extend(out) {
		out = out || {};
		for (var i = 1; i < arguments.length; i++) {
				if (!arguments[i]) {
						continue;
				}
				for (var key in arguments[i]) {
						if (arguments[i].hasOwnProperty(key) && arguments[i][key] !== undefined) {
								out[key] = arguments[i][key];
						}
				}
		}
		return out;
}

function cleanSelector(selector) {
		return selector.replace(/\W/g, '');
}

function matchSelector(elem, selector) {
		if ($) {
				return $(elem).is(selector);
		} else if (typeof selector === 'string') {
				return elementMatchesSelector.call(elem, selector);
		} else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object' && selector.length) {
				return selector.indexOf(elem) >= 0;
		} else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object' && selector.nodeType === 1) {
				return elem === selector;
		}
		return false;
}

function generateId() {
		var id;
		while (true) {
				id = ID_POOL_PREFIX + String(++_idPool);
				if (!_modals[id]) {
						break;
				}
		}
		return id;
}

function getModalId(elem) {
		var hasClass = false;
		var elemClasses = elem && elem.className && elem.className.split(' ') || [];

		for (var id in _modals) {
				var triggerSelectors = _modals[id].triggerSelectors.map(function (selector) {
						return selector.substring(1);
				});

				var dismissSelectors = _modals[id].dismissSelectors.map(function (selector) {
						return selector.substring(1);
				});

				if (!_modals[id].disable) {
						for (var i = 0, len = elemClasses.length; i < len; i++) {
								hasClass = triggerSelectors.indexOf(elemClasses[i]) === 0 || dismissSelectors.indexOf(elemClasses[i]) === 0;
								if (hasClass) {
										break;
								}
						}

						return id;
				}
		}
}

function hideModal(modalId) {
		var modal = _modals[modalId];
		var modalRoot;

		if (!modal) {
				return;
		}

		modalRoot = modal.root;

		modalRoot.setAttribute('data-modal', 'false');
		modalRoot.setAttribute('aria-hidden', 'false');
		modal.modalSelector[0].setAttribute('data-visible', 'false');
		modal.modalSelector[0].setAttribute('aria-hidden', 'true');
}

function onModalActivatorPress(evt) {

		var target = this;
		var modalId = getModalId(target);
		var modal = _modals[modalId];
		var modalRoot;
		var modalData;

		document.getElementById("overlay").style.display = "block";

		if (!modal) {
				return;
		}

		modalRoot = modal.root;
		modalData = modalRoot && modalRoot.getAttribute('data-modal');

		if (modalData && modalData === 'true') {
				return;
		}

		evt.preventDefault();
		evt.stopPropagation();

		modalRoot.setAttribute('data-modal', 'true');
		modalRoot.setAttribute('aria-hidden', 'true');
		modal.modalSelector[0].setAttribute('data-email', target.getAttribute('href'));
		modal.modalSelector[0].setAttribute('data-visible', 'true');
		modal.modalSelector[0].setAttribute('aria-hidden', 'false');
}

function onModalDismissorPress(evt) {

		document.getElementById("overlay").style.display = "none";

		var target = this;
		var modalId = getModalId(target);

		evt.preventDefault();
		evt.stopPropagation();

		hideModal(modalId);
}

/****************/
/* Modal Object */
/****************/
var BoostModal = {
		init: function init(config) {
				var options = extend({}, GlobalConfig, config);
				var triggerSelectors = options.triggerSelectors || [];
				var dismissSelectors = options.dismissSelectors || [];

				triggerSelectors = triggerSelectors.join(', ');
				dismissSelectors = dismissSelectors.join(', ');

				$(document).on('click', triggerSelectors, onModalActivatorPress);
				$(document).on('click', dismissSelectors, onModalDismissorPress);
		},

		set: function set() {
				var modalId, config;

				if (_typeof(arguments[0]) === 'object') {
						config = arguments[0];
				} else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
						modalId = arguments[0];
						config = arguments[1];
						if (!_modals[modalId]) {
								throw new Error('Section "' + modalId + '" doesn\'t exist!');
						}
				} else {
						return;
				}

				for (var key in config) {
						if (GlobalConfig[key] !== undefined) {
								if (modalId) {
										_modals[modalId][key] = config[key];
								} else if (config[key] !== undefined) {
										GlobalConfig[key] = config[key];
								}
						}
				}

				if (modalId) {
						// remove "undefined" items
						_modals[modalId] = extend({}, _modals[modalId]);
				}
		},

		add: function add() {
				var modalId;
				var config = {};

				if (_typeof(arguments[0]) === 'object') {
						config = arguments[0];
				} else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
						modalId = arguments[0];
						config = arguments[1];
				}

				if (!modalId) {
						modalId = typeof config.id === 'string' ? config.id : generateId();
				}

				if (_modals[modalId]) {
						throw new Error('Modal "' + modalId + '" already exists!');
				}

				_modals[modalId] = {};

				Modal.set(modalId, config);
		},

		destroy: function destroy() {
				window.removeEventListener('keyup', onKeyUp);
				Modal.clear();
				_idPool = 0;
				_ready = false;
		},

		clear: function clear() {
				_modals = {};
				_modalCount = 0;
				_defaultModalId = '';
				_lastModalId = '';
		}

};

window.Modal = BoostModal;

/*********************/
/* jQuery Interface  */
/*********************/
if ($) {
		$.Modal = function () {
				Modal.init();

				if (arguments.length > 0) {
						if ($.isPlainObject(arguments[0])) {
								return Modal.add(arguments[0]);
						} else if ($.type(arguments[0]) === 'string' && $.isFunction(Modal[arguments[0]])) {
								return Modal[arguments[0]].apply(Modal, [].slice.call(arguments, 1));
						}
				}

				return $.extend({}, Modal);
		};

		$.fn.Modal = function () {
				var config;

				if ($.isPlainObject(arguments[0])) {
						config = arguments[0];
				} else {
						config = {
								modalSelector: arguments[0]
						};
				}

				config.modalSelector = this;
				config.root = config.root || document.body;

				if (config.id) {
						Modal.remove(config.id);
				}

				Modal.add(config);
				Modal.init(config);

				return this;
		};
}

},{}],2:[function(require,module,exports){
"use strict";

require('../features/boost-modal.js');

jQuery.fn.InitializePage = function (option) {
    var defaults = {
        initialJsonData: null
    };
    var option = $.extend({}, defaults, option);

    //// Load JSON data from model
    var viewModelJs = JSON.parse(option.initialJsonData);
    var viewModel = ko.mapping.fromJS(viewModelJs);

    var pageContent = $(this);

    //// ViewModel to Send
    viewModel.FirstName = ko.observable();
    viewModel.LastName = ko.observable();
    viewModel.BusinessName = ko.observable();
    viewModel.BusinessAddress = ko.observable();
    viewModel.BusinessCity = ko.observable();
    viewModel.BusinessState = ko.observable();
    viewModel.BusinessZip = ko.observable();
    viewModel.BusinessPhone = ko.observable();
    viewModel.OtherPhone = ko.observable();
    viewModel.BusinessEmail = ko.observable();
    //viewModel.BriefDescription = ko.observable(); //AM-7999 - changed references for BriefDescription to LeagalIssueDescription so it matches the model
    viewModel.LegalIssueDescription = ko.observable();
    viewModel.BriefStatementOfBarriers = ko.observable();
    viewModel.HasReviewedProjectOpportunity = ko.observable();
    viewModel.HasReviewedIntroCopy = ko.observable();
    viewModel.NamesOfBusinessOwners = ko.observable();
    viewModel.KnownOrExpectedAdverseParties = ko.observable();
    viewModel.ReferringOrganizationOrPerson = ko.observable();
    viewModel.BusinessRevenuePriorTwoYears = ko.observable();
    viewModel.CurrentBusinessAssets = ko.observable();
    viewModel.NumberOfEmployees = ko.observable();
    viewModel.NumberOfYearsInOperation = ko.observable();
    viewModel.DescribeDayToDay = ko.observable();
    viewModel.DescribeOwnershipStructure = ko.observable();
    viewModel.UtilizingLegalServicesInOtherAreas = ko.observable();
    viewModel.HasAgreedToDisclaimer = ko.observable(true);
    viewModel.hasSubmitted = ko.observable(false);

    //// Components to handle validation of data
    viewModel.FirstNameValid = ko.observable(true);
    viewModel.LastNameValid = ko.observable(true);
    viewModel.BusinessNameValid = ko.observable(true);
    viewModel.BusinessAddressValid = ko.observable(true);
    viewModel.BusinessCityValid = ko.observable(true);
    viewModel.BusinessStateValid = ko.observable(true);
    viewModel.BusinessZipValid = ko.observable(true);
    viewModel.BusinessPhoneValid = ko.observable(true);
    viewModel.OtherPhoneValid = ko.observable(true);
    viewModel.BusinessEmailValid = ko.observable(true);
    viewModel.BriefDescriptionValid = ko.observable(true);
    viewModel.NamesOfBusinessOwnersValid = ko.observable(true);
    viewModel.KnownOrExpectedAdversePartiesValid = ko.observable(true);
    viewModel.CheckboxsValid = ko.observable(true);
    viewModel.SendEmailFailed = ko.observable(false);

    viewModel.GetRequestObject = function () {
        var reqObj = {
            FirstName: viewModel.FirstName(),
            LastName: viewModel.LastName(),
            BusinessName: viewModel.BusinessName(),
            BusinessAddress: viewModel.BusinessAddress(),
            BusinessCity: viewModel.BusinessCity(),
            BusinessState: viewModel.BusinessState,
            BusinessZip: viewModel.BusinessZip,
            BusinessPhone: viewModel.BusinessPhone,
            OtherPhone: viewModel.OtherPhone,
            BusinessEmail: viewModel.BusinessEmail,
            //BriefDescription: viewModel.BriefDescription,
            LegalIssueDescription: viewModel.LegalIssueDescription,
            BriefStatementOfBarriers: viewModel.BriefStatementOfBarriers,
            HasReviewedProjectOpportunity: viewModel.HasReviewedProjectOpportunity,
            HasReviewedIntroCopy: viewModel.HasReviewedIntroCopy,
            NamesOfBusinessOwners: viewModel.NamesOfBusinessOwners,
            KnownOrExpectedAdverseParties: viewModel.KnownOrExpectedAdverseParties,
            ReferringOrganizationOrPerson: viewModel.ReferringOrganizationOrPerson,
            BusinessRevenuePriorTwoYears: viewModel.BusinessRevenuePriorTwoYears,
            CurrentBusinessAssets: viewModel.CurrentBusinessAssets,
            HasAgreedToDisclaimer: viewModel.HasAgreedToDisclaimer,
            NumberOfEmployees: viewModel.NumberOfEmployees,
            NumberOfYearsInOperation: viewModel.NumberOfYearsInOperation,
            DescribeDayToDay: viewModel.DescribeDayToDay,
            DescribeOwnershipStructure: viewModel.DescribeOwnershipStructure,
            UtilizingLegalServicesInOtherAreas: viewModel.UtilizingLegalServicesInOtherAreas
        };
        return reqObj;
    };

    viewModel.isFormValidated = function () {

        if (viewModel.FirstName() == "" || viewModel.FirstName() == "undefined" || viewModel.FirstName() == null) {
            viewModel.FirstNameValid(false);
        } else {
            viewModel.FirstNameValid(true);
        }

        if (viewModel.LastName() == "" || viewModel.LastName() == "undefined" || viewModel.LastName() == null) {
            viewModel.LastNameValid(false);
        } else {
            viewModel.LastNameValid(true);
        }

        if (viewModel.BusinessName() == "" || viewModel.BusinessName() == "undefined" || viewModel.BusinessName() == null) {
            viewModel.BusinessNameValid(false);
        } else {
            viewModel.BusinessNameValid(true);
        }

        if (viewModel.BusinessAddress() == "" || viewModel.BusinessAddress() == "undefined" || viewModel.BusinessAddress() == null) {
            viewModel.BusinessAddressValid(false);
        } else {
            viewModel.BusinessAddressValid(true);
        }

        if (viewModel.BusinessCity() == "" || viewModel.BusinessCity() == "undefined" || viewModel.BusinessCity() == null) {
            viewModel.BusinessCityValid(false);
        } else {
            viewModel.BusinessCityValid(true);
        }

        if (viewModel.BusinessState() == "" || viewModel.BusinessState() == "undefined" || viewModel.BusinessState() == null) {
            viewModel.BusinessStateValid(false);
        } else {
            viewModel.BusinessStateValid(true);
        }

        if (viewModel.BusinessZip() == "" || viewModel.BusinessZip() == "undefined" || viewModel.BusinessZip() == null) {
            viewModel.BusinessZipValid(false);
        } else {
            viewModel.BusinessZipValid(true);
        }

        if (viewModel.BusinessPhone() == "" || viewModel.BusinessPhone() == "undefined" || viewModel.BusinessPhone() == null) {
            viewModel.BusinessPhoneValid(false);
        } else {
            viewModel.BusinessPhoneValid(true);
        }

        var re = /\S+@\S+\.\S+/;
        if (!re.test(viewModel.BusinessEmail())) {
            viewModel.BusinessEmailValid(false);
        } else {
            viewModel.BusinessEmailValid(true);
        }

        //if (viewModel.BriefDescription() == "" || viewModel.BriefDescription() == "undefined" || viewModel.BriefDescription() == null) {
        if (viewModel.LegalIssueDescription() == "" || viewModel.LegalIssueDescription() == "undefined" || viewModel.LegalIssueDescription() == null) {
            viewModel.BriefDescriptionValid(false);
        } else {
            viewModel.BriefDescriptionValid(true);
        }

        if (viewModel.NamesOfBusinessOwners() == "" || viewModel.NamesOfBusinessOwners() == "undefined" || viewModel.NamesOfBusinessOwners() == null) {
            viewModel.NamesOfBusinessOwnersValid(false);
        } else {
            viewModel.NamesOfBusinessOwnersValid(true);
        }

        var isInputValidated = viewModel.FirstNameValid() && viewModel.LastNameValid() && viewModel.BusinessNameValid() && viewModel.BusinessAddressValid() && viewModel.BusinessCityValid() && viewModel.BusinessStateValid() && viewModel.BusinessZipValid() && viewModel.BusinessPhoneValid() && viewModel.BusinessEmailValid() && viewModel.BriefDescriptionValid() && viewModel.NamesOfBusinessOwnersValid();

        var isCheckboxsValidated = viewModel.HasReviewedProjectOpportunity() && viewModel.HasAgreedToDisclaimer() && viewModel.HasReviewedIntroCopy();

        if (!isCheckboxsValidated) {
            viewModel.CheckboxsValid(false);
        } else {
            viewModel.CheckboxsValid(true);
        }

        var isValidated = isInputValidated && isCheckboxsValidated;

        return isValidated;
    };

    function initializePopup() {
        $('.js-boostConfirmationModal').Modal({
            triggerSelectors: ['.js-boostConfirmationModal-trigger'],
            dismissSelectors: ['.js-modalClose', '.js-modalButton-agree', '.js-modalButton-cancel']
        });
    }

    //// Generate Email
    viewModel.GenerateProBonoContactUsEmail = function () {

        if (viewModel.isFormValidated()) {

            initializePopup();

            var viewModelToSend = viewModel.GetRequestObject();

            $.ajax({
                url: "/main/general/probonoemail",
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.mapping.toJSON(viewModelToSend),
                cache: false,
                success: function success(data) {
                    if (data) {
                        viewModel.hasSubmitted(true);
                    } else {
                        viewModel.SendEmailFailed(true);
                    }
                },
                error: function error(xhr, textStatus, errorThrown) {
                    console.log(xhr);
                    console.log("textStatus : " + textStatus);
                    console.log("errorThrown : " + errorThrown);
                }
            });
        } else {
            var offset = $('.probono-landing').offset().top;
            $("html, body").animate({
                scrollTop: offset
            });
            return false;
        }
    };

    //// Apply Bindings
    ko.applyBindings(viewModel, pageContent.get(0));
};

},{"../features/boost-modal.js":1}],3:[function(require,module,exports){
'use strict';

require('./features/probono.js');

$('main.probono-landing').InitializePage({
    initialJsonData: initialJsonData
});

},{"./features/probono.js":2}]},{},[3]);
